export default "__VITE_ASSET__DvJtM5YT__"